var Alert = function () {
  function Alert() {}

  Alert.alert = function alert() {};

  return Alert;
}();

export default Alert;